import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function Tech() {
  const { t } = useLang();
  const c = t.tech;
  return (
    <section id="sostenibilidad" data-testid="tech-section" className="py-24 sm:py-32 border-t border-border">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section text-olive">
            {c.title}
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-8 lg:col-start-4">
            <p className="text-lg text-olive-soft leading-relaxed">{c.intro}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border">
          {c.items.map((it, i) => (
            <Reveal key={i} delay={i * 70} data-testid={`tech-card-${i}`} className="bg-ivory p-8 sm:p-12">
              <div className="flex items-baseline justify-between mb-6">
                <span className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta">{it.tag}</span>
                <span className="font-serif italic text-3xl text-olive-soft">0{i + 1}</span>
              </div>
              <p className="text-lg text-olive leading-relaxed">{it.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
